import { takeLatest } from 'redux-saga/effects';
import fetchDebitAndCreditLinesWorker from './accountInvoiceTableWorkerSaga';
import { FETCH_ACCOUNT_INVOICE_REQUEST } from '../../redux/modules/accountInvoiceTable/accountInvoiceTable-actions';

function* fetchAccountInvoiceTableWatcher() {
    yield takeLatest(FETCH_ACCOUNT_INVOICE_REQUEST, fetchDebitAndCreditLinesWorker);
}

export default fetchAccountInvoiceTableWatcher;
